import { Option } from "../HeaderMenuOption";
import FilterOptionList from "./FilterOptionList";
import { ColumnFilterProps } from "./types";
import { toggleListOption, useDistinctValues } from "./useDistinctValues";

const TextColumnFilter = ({ fieldName, formatter, get, selected, onChange }: ColumnFilterProps) => {
  const { options } = useDistinctValues(get, fieldName, selected.values);

  const toggle = (option: Option) => onChange({ operator: undefined, values: toggleListOption(selected.values, option) });

  return <FilterOptionList options={options} formatter={formatter} onToggle={toggle} />;
};

export default TextColumnFilter;
